import axios from "axios";
import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(43, 47, 50, 1);
  border-radius: 12px;
  overflow: hidden;
`;

const { REACT_APP_API_ENDPOINT } = process.env;

export const WidgetWeather = () => {
  const [weatherData, setWeatherData] = useState(null);
  const [fontSize, setFontSize] = useState(16);
  const containerRef = useRef(null);

  const updateFontSize = () => {
    if (containerRef.current) {
      const { width, height } = containerRef.current.getBoundingClientRect();
      const newFontSize = Math.min(width, height) * 0.2; // ปรับให้ font-size เป็น 25% ของ Container
      setFontSize(newFontSize);
    }
  };

  const getWeatherData = async () => {
    try {
      const resp = await axios.get(`${REACT_APP_API_ENDPOINT}/api/weather`);
      const result = _.get(resp, ["data", "result"]);
      setWeatherData(result);
    } catch (error) {
      console.log("Error fetching weather data: ", error);
    }
  };

  // useEffect(() => {
  //   const resizeObserver = new ResizeObserver(updateFontSize);

  //   if (containerRef.current) {
  //     resizeObserver.observe(containerRef.current);
  //   }

  //   updateFontSize();
  //   getWeatherData();

  //   return () => {
  //     if (containerRef.current) {
  //       resizeObserver.unobserve(containerRef.current);
  //     }
  //   };
  // }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(updateFontSize);

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    updateFontSize();
    getWeatherData();

    const intervalId = setInterval(() => {
      getWeatherData();
    }, 1500000);

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }

      clearInterval(intervalId);
    };
  }, []);

  const temperature = Math.round(_.get(weatherData, ["main", "temp"], 0));
  const weatherIcon = _.get(weatherData, ["weather_icon"], "");

  return (
    <Container ref={containerRef}>
      {weatherData && (
        <>
          <img
            src={weatherIcon}
            alt="Weather Icon"
            style={{
              objectFit: "contain",
              width: `${fontSize * 2}px`,
              height: `${fontSize * 2}px`,
              pointerEvents: "none",
            }}
          />
          <Text
            fontFamily="NotoSansThaiLooped"
            color={COLOR_WHITE}
            fontWeight="600"
            style={{
              fontSize: `${fontSize}px`,
              whiteSpace: "nowrap",
              marginLeft: 10,
            }}
          >
            {temperature}°
          </Text>
        </>
      )}
    </Container>
  );
};
